import { differenceInDays, parseISO } from 'date-fns'

export function getDaysAgo(dateTime: Date | string): number {
  const parsedDate = typeof dateTime === 'string' ? parseISO(dateTime) : dateTime
  const today = new Date()

  return differenceInDays(today, parsedDate)
}

export function formatDaysAgo(daysAgo: number): string {
  if (daysAgo === 0) {
    return 'Today'
  } else if (daysAgo === 1) {
    return 'Yesterday'
  } else if (daysAgo === -1) {
    return 'Tomorrow'
  } else if (daysAgo > 1) {
    return `${daysAgo} days ago`
  } else {
    return `In ${Math.abs(daysAgo)} days`
  }
}

export function formatCSVDate(date: Date): string {
  // eg: 09/06/2023 11:29:13 PM
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }
  return date.toLocaleString('en-US', options).replace(',', '')
}

export function formatPaymentDate(date: Date): string {
  // eg: 09/06/23 11:29 PM
  const options: Intl.DateTimeFormatOptions = {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }
  return date.toLocaleString('en-US', options).replace(',', '')
}

export function formatOnlyDate(date: Date): string {
  // eg: 09/06/2023
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  return date.toLocaleString('en-US', options).replace(',', '')
}

export function formatWrittenDate(date: Date): string {
  // eg: Sep 6, 2023, 11:29 PM
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }
  return date.toLocaleString('en-US', options)
}

export function formatTimeDay(date: Date): string {
  // eg: 11:29 PM, Sep 6
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
  }
  return date.toLocaleString('en-US', options)
}

export function formatDateNoSlashes(date: Date): string {
  // eg: 09062023
  return date
    .toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    })
    .replace(/\//g, '')
}

export function formatDateNoSlashesReverse(date: Date): string {
  // eg: 20230609
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}${month}${day}`
}

export function formatStepStatusDate(dateString: string): string {
  const date = new Date(dateString)

  if (isNaN(date.getTime())) {
    return 'Invalid Date'
  }

  const hours = date.getHours()
  const minutes = date.getMinutes()
  const ampm = hours >= 12 ? 'pm' : 'am'
  const formattedHours = hours % 12 || 12 // Convert 0 to 12 for 12 AM
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes

  const month = date.toLocaleString('default', { month: 'short' })
  const day = date.getDate()

  return `${formattedHours}:${formattedMinutes} ${ampm} ${month}. ${day}`
}

export function convertSLATime(slaTime: string): string {
  if (typeof slaTime === 'string' && slaTime.includes(' ')) {
    const [days, time] = slaTime.split(' ')
    const [hours, minutes, seconds] = time.split(':')

    const totalSeconds =
      Number(days) * 86400 + Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds)

    const d = Math.floor(totalSeconds / (3600 * 24))
    const h = Math.floor((totalSeconds % (3600 * 24)) / 3600)
    const m = Math.floor((totalSeconds % 3600) / 60)

    const parts: string[] = []
    if (d > 0) parts.push(`${d} day${d > 1 ? 's' : ''}`)
    if (h > 0) parts.push(`${h} hour${h > 1 ? 's' : ''}`)
    if (m > 0) parts.push(`${m} minute${m > 1 ? 's' : ''}`)

    if (parts.length > 1) {
      const lastPart = parts.pop()
      return `${parts.join(', ')} and ${lastPart}`
    } else {
      return `${parts[0]}`
    }
  }
  return slaTime
}

export function convertToDatetime(date: Date): string {
  return date.toISOString().slice(0, 19) + 'Z'
}
